import { render, staticRenderFns } from "./FormRendererField.vue?vue&type=template&id=8216dd70&"
import script from "./FormRendererField.vue?vue&type=script&lang=js&"
export * from "./FormRendererField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports